(function () {
  'use strict';

  var PAGE_SIZE = 6;

  var allManuals = window.atdUserManuals || [];
  var allCategories = window.atdUserManualCategories || [];
  var allLanguages = window.atdUserManualLanguages || [];

  // Collect unique products from all manuals
  var productSet = {};
  allManuals.forEach(function (m) {
    (m.products || []).forEach(function (p) {
      if (p) productSet[p] = true;
    });
  });
  var allProducts = Object.keys(productSet).sort();

  // DOM refs
  var panelCategory = document.getElementById('um-panel-category');
  var panelProduct = document.getElementById('um-panel-product');
  var panelLanguage = document.getElementById('um-panel-language');
  var resetBtn = document.getElementById('um-filter-reset');
  var searchInput = document.getElementById('um-search-input');
  var tbody = document.getElementById('um-manuals-tbody');
  var paginationNav = document.getElementById('um-pagination');

  if (!panelCategory || !tbody || !paginationNav) return;

  // State
  var state = {
    category: '',
    product: '',
    language: '',
    search: '',
    page: 1,
  };

  // ------ Helpers ------

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function highlightText(text, query) {
    if (!query) return escapeHtml(text);
    var escaped = escapeHtml(text);
    var escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var re = new RegExp('(' + escapedQuery + ')', 'gi');
    return escaped.replace(re, '<mark class="um-highlight">$1</mark>');
  }

  var PDF_ICON =
    `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.06777 15.4408C7.06777 15.0423 6.79121 14.8046 6.30323 14.8046C6.10397 14.8046 5.96902 14.8242 5.89844 14.843V16.1218C5.98201 16.1407 6.08476 16.1469 6.22638 16.1469C6.74651 16.1469 7.06777 15.8842 7.06777 15.4408Z" fill="#0D0D0D"/>
<path d="M10.0839 14.8179C9.86537 14.8179 9.72415 14.8367 9.64062 14.8563V17.6885C9.7242 17.7081 9.85915 17.7081 9.98116 17.7081C10.8677 17.7144 11.4458 17.2264 11.4458 16.1924C11.4521 15.2933 10.9252 14.8179 10.0839 14.8179Z" fill="#0D0D0D"/>
<path d="M15.7069 0H6.06754C4.65931 0 3.51317 1.14694 3.51317 2.55436V12H3.26369C2.69532 12 2.23438 12.4604 2.23438 13.0293V19.2717C2.23438 19.8405 2.69527 20.3009 3.26369 20.3009H3.51317V21.4456C3.51317 22.8546 4.65931 24 6.06754 24H19.22C20.6274 24 21.7737 22.8545 21.7737 21.4456V6.0455L15.7069 0ZM4.93469 14.1558C5.23634 14.1049 5.66035 14.0664 6.25774 14.0664C6.86145 14.0664 7.29173 14.1817 7.58084 14.4131C7.85701 14.6313 8.04338 14.9913 8.04338 15.415C8.04338 15.8386 7.90216 16.1988 7.6452 16.4427C7.31099 16.7573 6.81675 16.8986 6.23857 16.8986C6.1099 16.8986 5.99456 16.8922 5.90436 16.8797V18.4276H4.93469V14.1558ZM19.22 22.4356H6.06754C5.52227 22.4356 5.07825 21.9916 5.07825 21.4456V20.3009H17.3391C17.9075 20.3009 18.3684 19.8405 18.3684 19.2717V13.0293C18.3684 12.4604 17.9075 12 17.3391 12H5.07825V2.55436C5.07825 2.00989 5.52232 1.56587 6.06754 1.56587L15.1217 1.55641V4.90314C15.1217 5.88068 15.9148 6.67459 16.8931 6.67459L20.1716 6.66518L20.2085 21.4455C20.2085 21.9916 19.7653 22.4356 19.22 22.4356ZM8.66864 18.408V14.1558C9.02829 14.0986 9.49705 14.0664 9.99174 14.0664C10.8139 14.0664 11.347 14.2139 11.7647 14.5285C12.2143 14.8627 12.4967 15.3954 12.4967 16.1603C12.4967 16.9887 12.195 17.5607 11.7772 17.9136C11.3214 18.2925 10.6276 18.4722 9.77988 18.4722C9.27225 18.4722 8.9126 18.4401 8.66864 18.408ZM15.6787 15.8905V16.6867H14.1242V18.4276H13.1415V14.0986H15.7877V14.9011H14.1242V15.8905H15.6787Z" fill="#0D0D0D"/>
</svg>

    `;

  // ------ Panel population (radio buttons) ------

  function buildPanel(panelEl, options, filterKey) {
    panelEl.innerHTML = '';
    options.forEach(function (opt) {
      var label = document.createElement('label');
      label.className = 'um-filter__option';

      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'um-filter-' + filterKey;
      radio.value = opt;
      radio.className = 'um-filter__radio';

      var span = document.createElement('span');
      span.className = 'text-body-small text-color-primary-dark';
      span.textContent = opt;

      label.appendChild(radio);
      label.appendChild(span);
      panelEl.appendChild(label);

      radio.addEventListener('change', function () {
        state[filterKey] = this.value;
        state.page = 1;
        updateToggleLabel(panelEl, this.value);
        if (filterKey === 'category') rebuildProductPanel(this.value);
        closeAllPanels();
        render();
        updateUrlParams();
      });
    });
  }

  // ------ Product panel: search + scrollable radio list ------

  var productSearchInput = null;

  function buildProductPanel(panelEl, options) {
    panelEl.innerHTML = '';

    // Search input
    var searchWrapper = document.createElement('div');
    searchWrapper.className = 'um-product-search__wrapper';

    productSearchInput = document.createElement('input');
    productSearchInput.type = 'text';
    productSearchInput.className = 'um-product-search__input';
    productSearchInput.placeholder = 'Search products\u2026';
    productSearchInput.setAttribute('autocomplete', 'off');
    productSearchInput.style.display = "none";
    searchWrapper.appendChild(productSearchInput);
    panelEl.appendChild(searchWrapper);

    // Scrollable options list
    var listEl = document.createElement('div');
    listEl.className = 'um-product-search__list';
    panelEl.appendChild(listEl);

    function renderOptions(query) {
      listEl.innerHTML = '';
      var filtered = query
        ? options.filter(function (o) { return o.toLowerCase().indexOf(query.toLowerCase()) !== -1; })
        : options;

      if (filtered.length === 0) {
        var empty = document.createElement('span');
        empty.className = 'um-product-search__empty text-body-small';
        empty.textContent = 'No products found';
        listEl.appendChild(empty);
        return;
      }

      filtered.forEach(function (opt) {
        var label = document.createElement('label');
        label.className = 'um-filter__option';

        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'um-filter-product';
        radio.value = opt;
        radio.className = 'um-filter__radio';
        if (state.product === opt) radio.checked = true;

        var span = document.createElement('span');
        span.className = 'text-body-small text-color-primary-dark';
        span.textContent = opt;

        label.appendChild(radio);
        label.appendChild(span);
        listEl.appendChild(label);

        radio.addEventListener('change', function () {
          state.product = this.value;
          state.page = 1;
          updateToggleLabel(panelEl, this.value);
          closeAllPanels();
          render();
          updateUrlParams();
        });
      });
    }

    renderOptions('');

    productSearchInput.addEventListener('input', function () {
      renderOptions(this.value.trim());
    });

    // Prevent clicks inside the product panel from bubbling to the document
    // close handler — allows the search input to receive focus without closing the panel.
    panelEl.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    // Store renderOptions so reset can clear the search list
    panelEl._renderOptions = renderOptions;
  }

  function updateToggleLabel(panelEl, value) {
    var group = panelEl.closest('.um-filter__group');
    if (!group) return;
    var span = group.querySelector('.um-filter__toggle-label');
    if (!span) return;
    var defaultLabel = group.getAttribute('data-filter-key');
    // Capitalize first letter as placeholder label
    var placeholder = defaultLabel.charAt(0).toUpperCase() + defaultLabel.slice(1);
    span.textContent = value || placeholder;
  }

  function getProductsForCategory(cat) {
    if (!cat) return allProducts;
    var catLower = cat.toLowerCase();
    var set = {};
    allManuals.forEach(function (m) {
      var cats = (m.categories || []).map(function (c) { return c.toLowerCase(); });
      if (cats.indexOf(catLower) !== -1) {
        (m.products || []).forEach(function (p) { if (p) set[p] = true; });
      }
    });
    return Object.keys(set).sort();
  }

  function rebuildProductPanel(cat) {
    var products = getProductsForCategory(cat);
    // Clear product state if the selected product is not available for this category
    if (state.product && products.map(function (p) { return p.toLowerCase(); }).indexOf(state.product.toLowerCase()) === -1) {
      state.product = '';
      updateToggleLabel(panelProduct, '');
    }
    buildProductPanel(panelProduct, products);
    // Re-check the selected radio if still valid
    if (state.product) {
      var radio = panelProduct.querySelector('input[value="' + CSS.escape(state.product) + '"]');
      if (radio) radio.checked = true;
    }
  }

  function initPanels() {
    buildPanel(panelCategory, allCategories, 'category');
    buildProductPanel(panelProduct, allProducts);
    buildPanel(panelLanguage, allLanguages, 'language');
  }

  // ------ Panel open/close (same pattern as blog filter) ------

  var groups = document.querySelectorAll('.um-filter__group');

  function closeAllPanels() {
    groups.forEach(function (g) {
      var panel = g.querySelector('.um-filter__panel');
      if (panel) panel.hidden = true;
    });
  }

  groups.forEach(function (group) {
    var toggle = group.querySelector('.um-filter__toggle');
    var panel = group.querySelector('.um-filter__panel');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = !panel.hidden;
      closeAllPanels();
      if (!isOpen) panel.hidden = false;
    });
  });

  document.addEventListener('click', function () {
    closeAllPanels();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  // ------ URL params ------

  function readUrlParams() {
    var params = new URLSearchParams(window.location.search);
    state.category = params.get('category') || '';
    state.product = params.get('product') || '';
    state.language = params.get('language') || '';
    state.search = params.get('search') || '';
    var parsedPage = parseInt(params.get('page'), 10);
    var rawPage = isNaN(parsedPage) ? 1 : parsedPage;
    state.page = Math.max(1, rawPage);
    if (state.page !== rawPage) updateUrlParams();
  }

  function applyStateToInputs() {
    searchInput.value = state.search;

    ['category', 'product', 'language'].forEach(function (key) {
      var panelMap = { category: panelCategory, product: panelProduct, language: panelLanguage };
      var panel = panelMap[key];
      var val = state[key];
      if (val) {
        var radio = panel.querySelector('input[value="' + CSS.escape(val) + '"]');
        if (radio) radio.checked = true;
        updateToggleLabel(panel, val);
      }
    });
  }

  function updateUrlParams() {
    var params = new URLSearchParams();
    if (state.category) params.set('category', state.category);
    if (state.product) params.set('product', state.product);
    if (state.language) params.set('language', state.language);
    if (state.search) params.set('search', state.search);
    if (state.page > 1) params.set('page', state.page);
    var qs = params.toString();
    window.history.replaceState(
      {},
      '',
      window.location.pathname + (qs ? '?' + qs : '')
    );
  }

  // ------ Filtering ------

  function getFiltered() {
    var cat = state.category.toLowerCase();
    var prod = state.product.toLowerCase();
    var lang = state.language.toLowerCase();
    var search = state.search.toLowerCase();

    return allManuals.filter(function (m) {
      if (cat) {
        var cats = (m.categories || []).map(function (c) { return c.toLowerCase(); });
        if (cats.indexOf(cat) === -1) return false;
      }
      if (prod) {
        var prods = (m.products || []).map(function (p) { return p.toLowerCase(); });
        if (prods.indexOf(prod) === -1) return false;
      }
      if (lang) {
        var langs = (m.languages || []).map(function (l) { return l.toLowerCase(); });
        if (langs.indexOf(lang) === -1) return false;
      }
      if (search) {
        var inTitle = (m.title || '').toLowerCase().indexOf(search) !== -1;
        var inKeywords = (m.keywords || '').toLowerCase().indexOf(search) !== -1;
        if (!inTitle && !inKeywords) return false;
      }
      return true;
    });
  }

  // ------ Rendering ------

  function renderTable(filtered) {
    var start = (state.page - 1) * PAGE_SIZE;
    var pageItems = filtered.slice(start, start + PAGE_SIZE);

    if (filtered.length === 0) {
      tbody.innerHTML =
        '<tr><td colspan="2" class="um-table__empty">No results found.</td></tr>';
      return;
    }

    tbody.innerHTML = pageItems.map(function (m) {
      var titleHtml = highlightText(m.title, state.search);

      var downloadCell = m.fileUrl
        ? '<a href="' + escapeHtml(m.fileUrl) +
        '" class="um-download-btn" target="_blank" rel="noopener noreferrer">' +
        PDF_ICON + '<span class="text-color-text-base text-body-medium text-medium">Download</span></a>'
        : '<span class="um-no-file">\u2014</span>';

      return (
        '<tr class="um-table__row">' +
        '<td class="um-table__description text-color-text-base text-body-medium text-medium"><div>' + titleHtml + '</div></td>' +
        '<td class="um-table__downloads text-color-text-base text-body-medium text-medium">' + downloadCell + '</td>' +
        '</tr>'
      );
    }).join('');
  }

  function renderPagination(filtered) {
    var totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));

    // Hide pagination when everything fits on one page
    var paginationWrapper = paginationNav.closest('.atd-user-manuals-pagination');
    if (paginationWrapper) {
      paginationWrapper.style.display = totalPages <= 1 ? 'none' : '';
    }

    var html = '';

    html +=
      '<button class="atd-pagination__btn atd-pagination__btn--prev" type="button" data-page="prev"' +
      (state.page === 1 ? ' disabled' : '') +
      '><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M10.25 3.5L5.75 8L10.25 12.5" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg></button>';

    for (var i = 1; i <= totalPages; i++) {
      var isActive = i === state.page;
      var show = i === 1 || i === totalPages || Math.abs(i - state.page) <= 1;

      if (!show) {
        if (i === 2 && state.page > 3) {
          html += '<span class="atd-pagination__ellipses" aria-hidden="true">\u2026</span>';
        }
        if (i === totalPages - 1 && state.page < totalPages - 2) {
          html += '<span class="atd-pagination__ellipses" aria-hidden="true">\u2026</span>';
        }
        continue;
      }

      html +=
        '<button class="atd-pagination__btn atd-pagination__btn--page' +
        (isActive ? ' is-active' : '') +
        ' text-title-base text-color-text-heading title-font" type="button" data-page="' + i + '">' +
        i + '</button>';
    }

    html +=
      '<button class="atd-pagination__btn atd-pagination__btn--next" type="button" data-page="next"' +
      (state.page === totalPages ? ' disabled' : '') +
      '><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M5.75 3.5L10.25 8L5.75 12.5" stroke="black" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg></button>';

    paginationNav.innerHTML = html;
  }

  function render() {
    var filtered = getFiltered();
    var totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    var clampedPage = Math.min(Math.max(1, state.page), totalPages);
    if (clampedPage !== state.page) {
      state.page = clampedPage;
      updateUrlParams();
    }
    renderTable(filtered);
    renderPagination(filtered);
  }

  // ------ Events ------

  var onSearchInput = debounce(function () {
    state.search = searchInput.value.trim();
    state.page = 1;
    render();
    updateUrlParams();
  }, 300);

  searchInput.addEventListener('input', onSearchInput);

  resetBtn.addEventListener('click', function (e) {
    e.preventDefault();
    state.category = '';
    state.product = '';
    state.language = '';
    state.search = '';
    state.page = 1;

    // Clear radio selections and reset toggle labels
    [
      { panel: panelCategory, key: 'category' },
      { panel: panelProduct, key: 'product' },
      { panel: panelLanguage, key: 'language' },
    ].forEach(function (item) {
      var radios = item.panel.querySelectorAll('input[type="radio"]');
      radios.forEach(function (r) { r.checked = false; });
      updateToggleLabel(item.panel, '');
    });

    // Reset product panel to show all products
    rebuildProductPanel('');

    searchInput.value = '';
    render();
    updateUrlParams();
  });

  paginationNav.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-page]');
    if (!btn || btn.disabled) return;
    var page = btn.getAttribute('data-page');
    var filtered = getFiltered();
    var totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));

    if (page === 'prev') {
      if (state.page > 1) state.page--;
    } else if (page === 'next') {
      if (state.page < totalPages) state.page++;
    } else {
      state.page = parseInt(page, 10);
    }

    render();
    updateUrlParams();

    var section = document.querySelector('.atd-user-manuals-section');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ------ Init ------
  initPanels();
  readUrlParams();
  if (state.category) rebuildProductPanel(state.category);
  applyStateToInputs();
  render();
})();
